
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/topcommercialcleaners/privacy-policy",
      function () {
        return require("private-next-pages/topcommercialcleaners/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/topcommercialcleaners/privacy-policy"])
      });
    }
  